import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer';
import { Helmet } from "react-helmet-async";

export default function Gmfmalaysia() {
  return (
    <>
        <Helmet>
            <title>GMF Malaysia | Gandhi Mandela Foundation</title>
            <meta name="description" content="GMF Malaysia" />
            <link rel="canonical" href="/gmfmalaysia" />
        </Helmet>
    <Header/>
            <section className="page-header">
                <div className="container">
                <div className="breadcrumb">
                    <a href="/">Home</a>
                    <span>/</span>
                    <span>GMF Malaysia</span>
                </div>
                <h1>GMF Malaysia</h1>
                </div>
            </section>
            
            <section className="board-members">
            <div className="container">
                <div className="members-grid">
                    <div className="member-card">
                        <div className="member-img">
                        <img src="img/members/JOHN-FRANCIS.png" alt="JOHN FRANCIS" />
                        </div>
                        <h3>JOHN FRANCIS</h3>
                        <span>(President Malaysia)</span>
                    </div>
                    <div className="member-card">
                        <div className="member-img">
                        <img src="img/members/Dr.-Jayanthi-Raja-Ratenam.png" alt="DR. JAYANTHI RAJA RATENAM" />
                        </div>
                        <h3>DR. JAYANTHI RAJA RATENAM</h3>
                        <span>(Vice President Malaysia)</span>
                    </div>
                </div>
            </div>
            </section>
            {/* =========================
            FOOTER
            ========================== */}
        <Footer/>
        </>
  )
}
